$( document ).ready(function() {

    $('.variable-3').on('init', function(event, slick){

        $(this).toArray().forEach(function(variable3){

            if ( variable3.clientHeight > 0 ) {
                
                var imgs = [].slice.call(variable3.getElementsByTagName('img'))

                lazyload(imgs);
            }
        });
        
    });

    $('.variable-4').on('init', function(event, slick){

        $(this).toArray().forEach(function(variable4){

            if ( variable4.clientHeight > 0 ) {
                
                var imgs = [].slice.call(variable4.getElementsByTagName('img'))

                lazyload(imgs);
            }
        });
    });

    // slick js
    // 單排3格
    $(".variable-3").slick({
        dots: false, //是否顯示下方導航列
        infinite: false, //是否重複循環輪播
        speed: 300,
        slidesToShow: 3, //輪播顯示個數
        slidesToScroll: 3, //輪播捲動個數
        autoplay: false, //是否自動播放
        autoplaySpeed: 1000,
        centerMode: false,
        lazyLoad: 'ondemand',
        variableWidth: false, //開啟時無法設定顯示筆數
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.3,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            } 
        ]
    });
    //特殊版型 會員登入3+2格
    $(".variable-special3").slick({
        dots: false, //是否顯示下方導航列
        infinite: false, //是否重複循環輪播
        speed: 300,
        slidesToShow: 2.1, //輪播顯示個數
        slidesToScroll: 2, //輪播捲動個數
        autoplay: false, //是否自動播放
        autoplaySpeed: 1000,
        centerMode: false,
        lazyLoad: 'ondemand',
        variableWidth: false, //開啟時無法設定顯示筆數
        responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: 1.8,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false
                }    
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 1.7,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1.8,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1.8,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            }
        ]
    });
    //特殊版型 4.5格
    $(".variable-special-subindex").slick({
        dots: false, //是否顯示下方導航列
        infinite: false, //是否重複循環輪播
        speed: 300,
        slidesToShow: 3.8, //輪播顯示個數
        slidesToScroll: 3, //輪播捲動個數
        autoplay: false, //是否自動播放
        autoplaySpeed: 1000,
        centerMode: false,
        lazyLoad: 'ondemand',
        variableWidth: false, //開啟時無法設定顯示筆數
        responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3.8,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }    
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3.8,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.8,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            }
        ]
    });
    //特殊版型 H (瀏覽紀錄、商品價格) 4.5格
    $(".variable-special4").slick({
        dots: false, //是否顯示下方導航列
        infinite: false, //是否重複循環輪播
        speed: 300,
        slidesToShow: 3.8, //輪播顯示個數
        slidesToScroll: 3, //輪播捲動個數
        autoplay: false, //是否自動播放
        autoplaySpeed: 1000,
        centerMode: false,
        lazyLoad: 'ondemand',
        variableWidth: false, //開啟時無法設定顯示筆數
        responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3.2,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }    
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3.2,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            }
        ]
    });

    $(".variable-horizontal3").slick({
        dots: false, //是否顯示下方導航列
        infinite: false, //是否重複循環輪播
        speed: 300,
        slidesToShow: 3, //輪播顯示個數
        slidesToScroll: 3, //輪播捲動個數
        autoplay: false, //是否自動播放
        autoplaySpeed: 1000,
        centerMode: false,
        lazyLoad: 'ondemand',
        variableWidth: false, //開啟時無法設定顯示筆數
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1.8,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            }
        ]
    });
    // 單排4格 雙排8格 雙排6格
    $(".variable-4").slick({
        dots: false, //是否顯示下方導航列
        infinite: false, //是否重複循環輪播
        speed: 300,
        slidesToShow: 4, //輪播顯示個數
        slidesToScroll: 4, //輪播捲動個數
        autoplay: false, //是否自動播放
        autoplaySpeed: 1000,
        centerMode: false,
        lazyLoad: 'ondemand',
        variableWidth: false, //開啟時無法設定顯示筆數
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3.3,
                    slidesToScroll: 3,
                    swipeToSlide: true,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.3,
                    slidesToScroll: 2,
                    swipeToSlide: true,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    swipeToSlide: true,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            }
        ]
    });
    // 單排5格 雙排10格
    $(".variable-5").slick({
        dots: false, //是否顯示下方導航列
        infinite: false, //是否重複循環輪播
        speed: 300,
        slidesToShow: 5, //輪播顯示個數
        slidesToScroll: 5, //輪播捲動個數
        autoplay: false, //是否自動播放
        autoplaySpeed: 1000,
        centerMode: false,
        lazyLoad: 'ondemand',
        variableWidth: false, //開啟時無法設定顯示筆數
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.3,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            }
        ]
    });
    // 單排6格 雙排12格
    $(".variable-6").slick({
        dots: false, //是否顯示下方導航列
        infinite: false, //是否重複循環輪播
        speed: 300,
        slidesToShow: 6, //輪播顯示個數
        slidesToScroll: 6, //輪播捲動個數
        autoplay: false, //是否自動播放
        autoplaySpeed: 1000,
        centerMode: false,
        lazyLoad: 'ondemand',
        variableWidth: false, //開啟時無法設定顯示筆數
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3.3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.3,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: false,
                }
            }
        ]
    });

    // 特殊模組 3格+5列多連結
    if ($(".variable-special-3plus5")) {
        $(".variable-special-3plus5").slick({
            dots: false, //是否顯示下方導航列
            infinite: false, //是否重複循環輪播
            speed: 300,
            slidesToShow: 3, //輪播顯示個數
            slidesToScroll: 3, //輪播捲動個數
            autoplay: false, //是否自動播放
            autoplaySpeed: 1000,
            centerMode: false,
            arrows: false,
            lazyLoad: 'ondemand',
            variableWidth: false, //開啟時無法設定顯示筆數
            responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        dots: false,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: false,
                        dots: false,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2.2,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        arrows: false,
                    }
                }
            ]
        });
    }

    $(window).resize(function () {
        $('.variable-onlymobile').slick('resize');
    });

    // 修正-切換tab時必須 refresh slick
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        e.target
        e.relatedTarget
        $('.variable-3').slick('setPosition');
        $('.variable-4').slick('setPosition');
        $('.variable-5').slick('setPosition');
        $('.variable-6').slick('setPosition');
    });

    // 切換頁籤 卡片模組navtabs        
    $('.nav-arrowDown').on('click', function (e) {
        $(this).parent().parent('.wrapper-relative').find('.nav-tabs-wrapper').toggleClass('active');
        e.preventDefault();
    });
    $('.nav-arrowUp').on('click', function (e) {
        $(this).parent().parent().parent().parent('.wrapper-relative').find('.nav-tabs-wrapper').removeClass('active');
        e.preventDefault();
    });
    $('.nav-tabs-wrapper ul li a').on('click', function (e) {
        if ($(this).is('[href*="#"]')) {
            $(this).parent().parent().parent().parent('.nav-tabs-wrapper').removeClass('active');
            e.preventDefault();
        } else {
            $(this).parent().parent().parent().parent('.nav-tabs-wrapper').removeClass('active');
        }
    });

    // 切換頁籤 次館分類模組navtabs   
    $('#nav-pintop .nav-arrowDown').on('click', function (e) {
        $(this).parent('.nav-tabs-wrapper').toggleClass('active');
        e.preventDefault();
    });
    $('#nav-pintop .nav-arrowUp').on('click', function (e) {
        $(this).parent().parent().parent('.nav-tabs-wrapper').removeClass('active');
        e.preventDefault();
    });
    $('#nav-pintop .nav-tabs-wrapper ul li a').on('click', function (e) {
        $(this).parent().parent().parent().parent('.nav-tabs-wrapper').removeClass('active');
        e.preventDefault();
    });

    // for normal image
    var lazyImages = [].slice.call(document.querySelectorAll('.lazy-image'))

    lazyload(lazyImages)

    window.addEventListener('scroll', throttle(function(){lazyload(lazyImages)}, 50))
    window.addEventListener('resize', throttle(function(){lazyload(lazyImages)}, 50))

    // for slick image
    var lazyImagesSlick = [].slice.call(document.querySelectorAll('.lazy-image-slick'))
    
    window.addEventListener('scroll', throttle(function(){lazyload(lazyImagesSlick)}, 50))
    window.addEventListener('resize', throttle(function(){lazyload(lazyImagesSlick)}, 50))
    var navLis = document.querySelectorAll('.nav-li')
    for (var i = 0; i < navLis.length; i++) {
        navLis[i].addEventListener('click', throttle(function(){lazyload(lazyImagesSlick)}, 50))
    }
    
    // nav-tabs-wrapper 行動版-項目小於3個時置中對齊
    $( '.nav-tabs-wrapper' ).each(function() {
        if ($(window).width() <= 1024) {
            if ( $(this).find('.nav-underline li').length < 4 ) {
                $(this).find('.nav-tabs').css('width','100%').css('justify-content','center');
                $(this).find('.nav-arrowDown').remove();
                $(this).find('.bar-expand').remove();
                $(this).find('.nav-scroll').css('width','100%');
            }
        }
    });

});

// 引入監控YT影片播放/暫停播放(社群優惠專區模組)
let tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let players = {};
let count = 0;

const playList = document.querySelectorAll('[id^="YT-player"]');

function onYouTubeIframeAPIReady() {
    playList.forEach(playerItem => {
        players[playerItem.id] = new YT.Player(playerItem.id, {
            events: {
                'onReady': onPlayerReady
            }
        });
    })
}

function onPlayerReady(event) {
    count++;
    // 等所有影片都準備好後，才開始監控
    if(count === playList.length) {
    setupObservers();
    }
    
}

//開始監控
function setupObservers() {
  const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const iframe = entry.target.querySelector('iframe');
            const playerId = iframe ? iframe.id : null; //是否有iframe
            if(!playerId) return;
            const player = players[playerId];
            if (entry.isIntersecting) {
                player && player.playVideo();
            } else {
                player && player.pauseVideo();
            }
        });
    }, {
        threshold: 0.6 // 需要 60% 的元素可見才觸發callback
    });

    document.querySelectorAll('.social-media-module').forEach(section => {
        observer.observe(section);
    });

}